import React from 'react';
import { Box, Dialog, Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useSelector } from 'react-redux';

import exit from '@assets/exitIcon.svg';
import { getLocalizedContent as l } from '@helpers/languages';
import content from './WireTransferModal.json';

const useStyles = makeStyles(() => ({
  title: {
    fontFamily: 'SchnyderSLight',
  },
  content: {
    fontWeight: '400',
  },
  bold: {
    fontWeight: '500',
    letterSpacing: '-1px',
  },
  paddingTop10: {
    paddingTop: '10px',
  },
  paddingBottom10: {
    paddingBottom: '10px',
  },
  marginTop10: {
    marginTop: '10px',
  },
  marginBottom10: {
    marginBottom: '10px',
  },
}));

export const WireTransferModal = ({ onClose, open, orderId }) => {
  const classes = useStyles();
  const { prefixLanguage } = useSelector(({ appState }) => appState);
  const language = prefixLanguage || 'en';

  return (
    <Dialog onClose={onClose} open={open}>
      <Grid container direction="row" justifyContent="flex-end">
        <Box p={2} onClick={onClose} style={{ cursor: 'pointer' }}>
          <img src={exit} alt="exit" />
        </Box>
      </Grid>
      <Box pl={4} pr={4} pt={0} pb={4}>
        <Box>
          <Grid item xs={12}>
            <Typography variant="h5" className={classes.content}>
              {l(content.check.title, language)}
            </Typography>
          </Grid>
          <Grid
            container
            spacing={2}
            pb={2}
            pt={4}
            className={classes.marginTop10}
          >
            <Grid item xs={5} className={classes.bold}>
              <Typography>
                {l(content.check.payableToLabel, language)}
              </Typography>
            </Grid>
            <Grid item xs={5}>
              <Typography>
                {l(content.check.payableToValue, language)}
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={2} pb={2}>
            <Grid item xs={5} className={classes.bold}>
              <Typography>
                {l(content.check.mailingAddressLabel, language)}
              </Typography>
            </Grid>
            <Grid item xs={7}>
              <Typography>
                {l(content.check.mailingAddressValue1, language)}
              </Typography>
              <Typography>
                {l(content.check.mailingAddressValue2, language)}
              </Typography>
              <Typography>
                {l(content.check.mailingAddressValue3, language)}
              </Typography>
            </Grid>
          </Grid>

          <Box>
            <Typography
              variant="body2"
              className={`${classes.content} ${classes.paddingTop10}`}
            >
              {l(content.check.checkNote1, language)}
            </Typography>
            <Typography variant="body2" className={classes.content}>
              {l(content.check.checkNote2, language)}
            </Typography>
          </Box>

          <hr className={`${classes.marginTop10} ${classes.marginBottom10}`} />

          <Grid item xs={12} pt={10} className={classes.paddingBottom10}>
            <Typography variant="h5" className={classes.content}>
              {l(content.stepTitle, language)}
            </Typography>
          </Grid>
          <Box pb={2}>
            <Typography variant="body2" className={classes.content}>
              {l(content.overview, language)} {orderId}
              {l(content.overview2, language)}
            </Typography>
          </Box>
          <Box pb={0}>
            <Typography variant="body2" className={classes.content}>
              {l(content.seeInstructions, language)}
            </Typography>
          </Box>

          <Box pb={2} className={classes.content}>
            <Grid container spacing={2} className={classes.marginTop10}>
              <Grid item xs={5} className={classes.bold}>
                <Typography>{l(content.field1, language)}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>{orderId}</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} pb={2}>
              <Grid item xs={5} className={classes.bold}>
                <Typography>{l(content.field2, language)}</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{l(content.field2Value, language)}</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} pb={2}>
              <Grid item xs={5} className={classes.bold}>
                <Typography>{l(content.field3, language)}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>{l(content.field3Value, language)}</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} pb={2}>
              <Grid item xs={5} className={classes.bold}>
                <Typography>{l(content.field4, language)}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>{l(content.field4Value, language)}</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} pb={2}>
              <Grid item xs={5} className={classes.bold}>
                <Typography>{l(content.field5, language)}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>{l(content.field5Value, language)}</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} pb={2}>
              <Grid item xs={5} className={classes.bold}>
                <Typography>{l(content.field6, language)}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>{l(content.field6Value, language)}</Typography>
              </Grid>
            </Grid>

            <Grid container spacing={2} pb={2}>
              <Grid item xs={5} className={classes.bold}>
                <Typography>{l(content.field7, language)}</Typography>
              </Grid>
              <Grid item xs={5}>
                <Typography>{l(content.field7Value1, language)}</Typography>
                <Typography>{l(content.field7Value2, language)}</Typography>
                <Typography>{l(content.field7Value3, language)}</Typography>
              </Grid>
            </Grid>
          </Box>

          <Box>
            <Typography variant="body2" className={classes.content}>
              {l(content.domesticTransfersOnly, language)}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};
